export default __webpack_public_path__ + "static/media/logovshop.eb31eb79.png";